<template>
    <div class="com-right-content text-white">
        <div style="box-sizing: border-box;">
            <BlockBox title="运费分析" enTitle="Freight Cost Analysis" height="340">
                <template #content>
                    <div style="padding:0;box-sizing: border-box">
                        <div id="chartCddjtj" style="height:245px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
        <div class="margin-top-15">
            <BlockBox title="车辆异常提醒" enTitle="Vehicle Abnormality" height="206">
                <template #content>
                    <!-- <div style="padding:0 15px;box-sizing: border-box">
                        <div class="text-center  bigNum" style="height:90px;color:#ff94a3;line-height: 90px;">
                            {{item.carWarningNum?item.carWarningNum:'0'}}
                        </div>
                    </div> -->
                    <div class="numBox">
                        <div class="num text-green bigNum">{{item.workerNum?item.workerNum:0}}</div>
                    </div>
                </template>
            </BlockBox>
        </div>

        <div class="margin-top-15">
            <BlockBox title="即时下单" enTitle="lmmediate order" height="356">
                <template #content>
                    <div style="padding:0 15px;box-sizing: border-box">
                        <div class="shtjBox margin-top-10">
                            <div class="swiper" id="swiperJsxd">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="(obj,index) in dkList" :key="index">
                                        <div class="shtjItem base-font-14">
                                            <el-image class="notcieIcon" :src="notice"></el-image>用户<span
                                                class="text-blue">{{maskString(obj.memberNickName,3)}}</span>于{{formatTimestamp(obj.createTime)}}<span
                                                class="text-green">下单成功</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </BlockBox>
        </div>



    </div>
</template>

<script>
    import echartMixins from "@/utils/resizeMixins";
    import BlockBox from '@/views/components/blockBox2'
    import Swiper from 'swiper/swiper-bundle';
    import notice from '@/assets/img/notice.png'
    import {
        wlRightData
    } from "@/api/api";
    export default {
        name: "cityGreenLand",
        components: {
            BlockBox
        },
        mixins: [echartMixins],
        data() {
            return {
                item: {},
                notice,
                colors: ['#f0792a', '#4b3eeb', '#247bf1', "#67e591", '#05d3f8', '#c0f02a', ],

                // mrhnDay: ['12/05', '12/06', '12/07', '12/08', '12/09'],
                //开始***************
                timerRight: null,
                dkList: [],

                mdshmxConfig: {
                    header: ['时间', '门店', '品类', '重量', '金额', '减碳量kg'],
                    indexHeader: "序号",
                    data: [],
                    index: true,
                    columnWidth: [70, 110, 100, 100]
                },
                swiperShow: false,
            }
        },
        mounted() {
            this.changeData()
            // this.changeDataTwo();
            this.timerRight = setTimeout(() => {
                this.changeData()
            }, 60000);

        },
        beforeDestroy() {
            clearTimeout(this.timerRight);
        },
        methods: {
           async changeData() {
                let _self = this
                await  wlRightData().then(res => {
                    _self.item = res.data;
                    _self.dkList = res.data.orderList;
                     console.log(_self.dkList,'_self.dkList')
                     _self.initSwiper()
                    _self.$nextTick(function() {
                        _self.drawCddjtj();
                        
                    });
                });
            },
            initSwiper() {
                new Swiper('#swiperJsxd', {
                    autoplay: true, //可选选项，自动滑动
                    direction: 'vertical',
                    height: 299, //你的slide高度
                    slidesPerView:6,
                })
            },

            drawCddjtj() {
                this.chart = this.$echarts.init(document.getElementById("chartCddjtj"));
                //let data=[{name: "纸壳", value: 25},{name: "塑料", value: 36}];
                let data = this.item.totalMoneyList;
                let dateList = [];
                let dateValue = [];
                data.forEach(obj => {
                    dateList.push(obj.name);
                    dateValue.push(obj.value);
                })
                let option = {
                    grid: {
                        left: '3%',
                        right: '3.5%',
                        bottom: '3%',
                        top: 20,
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',

                        axisTick: {
                            show: false,
                        },
                        data: dateList,
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.9)', //更改坐标轴文字颜色
                                fontSize: 10 //更改坐标轴文字大小
                            }
                        },
                        splitLine: { //网格线
                            lineStyle: {
                                type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
                                color: ['rgba(45,163,255,0.6)']
                            },
                            show: true //隐藏或显示
                        },
                        axisLine: {
                            show: false, //隐藏或显示
                            lineStyle: {
                                color: '#2da3ff'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisTick: {
                            show: false,
                        },
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.9)', //更改坐标轴文字颜色
                                fontSize: 10 //更改坐标轴文字大小
                            }
                        },
                        splitLine: { //网格线
                            lineStyle: {
                                type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
                                color: ['rgba(45,163,255,0.5)']
                            },
                            show: true //隐藏或显示
                        },
                        axisLine: {
                            show: false, //隐藏或显示
                            lineStyle: {
                                color: '#ffffff',
                                fontSize: 10
                            }
                        }
                    },
                    series: [{
                        name: '运费/万元',
                        type: 'bar',
                        barWidth: 9,
                        data: dateValue,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: {
                                        //数值样式
                                        color: 'white',
                                        fontSize: 12,
                                    },
                                },
                                color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                            offset: 0,
                                            color: 'rgba(1, 108, 190, 1)', // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(1, 38, 77, 1)' // 100% 处的颜色
                                        }
                                    ],
                                    global: false, // 缺省为 false
                                }
                            }
                        },

                    }, ]
                };
                // echart图表自适应
                this.chart.setOption(option)
                window.addEventListener("resize", () => {
                    this.chart.resize();
                });
            },

            
            formatTimestamp(timestamp) {
                  const date = new Date(timestamp);
                  const year = date.getFullYear();
                  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的，所以要+1，并确保是两位数
                  const day = String(date.getDate()).padStart(2, '0');
                  const hours = String(date.getHours()).padStart(2, '0');
                  const minutes = String(date.getMinutes()).padStart(2, '0');
                  const seconds = String(date.getSeconds()).padStart(2, '0');
                  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
             },
             maskString(str, start) {
               // 截取前三位
               const prefix = str.slice(0, start);
               // 计算剩余部分的长度
               const remainingLength = str.length - start;
               // 创建足够数量的星号来代替剩余部分
               // const mask = '*'.repeat(remainingLength);
               // 拼接前缀和星号部分
               return prefix + (remainingLength>0?'*':'');
             }


        }
    }
</script>

<style lang="scss">
    .com-right-content {
        min-height: 500px;
        padding: 14px 15px 15px 15px;
        box-sizing: border-box;
        
        .numBox{width:75%;height:150px;padding: 12px 14px;box-sizing: border-box;
            background: url("../../assets/img/ym.png") center no-repeat;margin:0 auto;
            background-size: 100% 100%;
            .num{height: 126px;line-height:126px;text-align: center;box-shadow: 0 0 50px rgba(48, 11, 205, 0.5) inset;border-radius: 10px;color:#ff94a3;}
        
        }
        .wzdjItem {
            width: 100%;
            height: 35px;
            line-height: 21px;
            padding: 11px 0;
            cursor: pointer;
        }

        .wzdjItem:hover {
            color: #006AF6;
        }

        .wzdjItem .leftNum {
            width: 21px;
            height: 21px;
            border-radius: 2px;
            background: #006AF6;
            line-height: 21px;
            text-align: center;
        }

        .wzdjItem .leftNum.one {
            background: -webkit-linear-gradient(top, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom, rgba(255, 72, 0, 1), rgba(178, 0, 0, 1));
        }

        .wzdjItem .leftNum.two {
            background: -webkit-linear-gradient(top, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
            /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
            /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
            /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom, rgba(255, 174, 0, 1), rgba(167, 98, 0, 1));
        }

        .shtjBox {
            height: 300px;

            & .swiper {
                height: 300px;
                .swiper-slide{}
            }
        }
    }


    .hnzbLable {
        margin-top: 10px;
    }

    .hnzbLable .itemLable {
        line-height: 1;
        border: 1px solid;
        color: #2196f3;
        font-size: 12px;
        padding: 5px 7px;
        border-radius: 1px;
    }

    .hnzbLable .itemLable+.itemLable {
        margin-left: 7px;
    }

    .hnzbLable .itemLable.checked {
        background: #006AF6;
        color: #FFFFFF;
        border-color: #006AF6;
    }

    //调整区域****************
    .padding-top-10 {
        padding-top: 10px;
    }

    .videoBox {
        width: 100%;
        height: 205px;
        border-radius: 10rpx;
        overflow: hidden;

        iframe {
            width: 100%;
            height: 240px;
        }
    }

    .text-white {
        color: #FFFFFF;
    }

    .enTitle {
        padding-left: 3px;
        font-size: 13px;
        border-left: 2px solid #FFFFFF;
        margin-left: 7px;
        font-weight: lighter;
    }

    .base-titleBox-flex {
        padding-top: 9px;
        line-height: 1
    }

    .bigNum {
        font-weight: bold;
        line-height: 130px;
        font-size: 48px;
    }

    .text-green {
        color: #15ff15;
    }

    .midTitleBox {
        font-size: 15px;
        font-weight: bold;
        color: #FFFFFF;
        padding-left: 20px;
        box-sizing: border-box;
    }

    .base-font-16 {
        font-size: 16px;
    }

    .text-bold {
        font-weight: bold;
    }

    .shtjItem {
        width: 100%;
        height: 38px;
        line-height: 38px;
        border: 1px solid #155898;
        line-height: 38px;
        padding: 0 5px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .shtjItem:hover {
        background: #155898;
    }

    .shtjBox {
        height: 200px;

        & .swiper {
            height: 200px;
        }
    }
</style>